(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("vue"));
	else if(typeof define === 'function' && define.amd)
		define("table-tree-grid", ["vue"], factory);
	else if(typeof exports === 'object')
		exports["table-tree-grid"] = factory(require("vue"));
	else
		root["table-tree-grid"] = factory(root["Vue"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_68__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition